export const SUCURSALES = {
  mercado: {
    nombre: 'Mercado San Miguel',
    whatsapp: '5493875212300',
  },
  leguizamon: {
    nombre: 'Leguizamón',
    whatsapp: '5493874319215',
  },
};
